const BC_LIST_PROPS = {
  itemScope: true,
  itemType: 'https://schema.org/BreadcrumbList',
};

const BC_LIST_ELE_PROPS = {
  itemProp: 'itemListElement',
  itemScope: true,
  itemType: 'https://schema.org/ListItem',
};

const BC_ITEM_PROPS = {
  itemProp: 'item',
  itemScope: true,
  itemType: 'https://schema.org/WebPage',
};

export { BC_LIST_PROPS, BC_LIST_ELE_PROPS, BC_ITEM_PROPS };
